<template>
  <div class="row pt-2">
    <div class="col" v-if="actionAccesDecision.modifierActionDecision || modifierButton">
      <Button label="Modifier" @click="modifier" :disabled="isDataLoading"/>
    </div>
    <div class="col" v-if="actionAccesDecision.imprimerActionDecision && impSu">
      <Button label="Imprimer" @click="imprimerSujet" :disabled="isDataLoading"/>
    </div>
    <div class="col" v-if="isSociete && actionAccesDecision.societeImprimercdx0003ActionDecision">
      <Button label="Imprimer" @click="imprimerSociete" :disabled="isDataLoading"/>
    </div>
    <div class="col" v-if="actionAccesDecision.imprimerCompletActionDecision">
      <Button label="Imprimer complet" @click="imprimerSujetComplet" :disabled="isDataLoading"/>
    </div>
    <div class="col" v-if="actionAccesDecision.auditAccesActionDecision">
      <Button label="Audit des accès" @click="auditAcces" :disabled="isDataLoading"/>
    </div>
    <div class="col" v-if="actionAccesDecision.auditChangementsActionDecision">
      <Button label="Audit des modifications" @click="auditModifications" :disabled="isDataLoading"/>
    </div>
    <div class="col" v-if="actionAccesDecision.ajouterDeboursActionDecision && categorieDossier == 26672">
      <Button label="Débours" @click="debours" :disabled="isDataLoading"/>
    </div>
    <div class="col">
      <Button label="Fermer" @click="fermer"/>
    </div>
  </div>
</template>

<script>

export default {
  name: "ButtonBarConsulter",
  props: ['actionAccesDecision', 'modifierButton', 'isDataLoading', 'categorieDossier', 'impSu', 'isSociete'],
  emits: ['fermer', 'modifier', 'auditModifications', 'auditAcces', 'debours', 'imprimerSujet', 'imprimerSujetComplet', 'imprimerSociete'],
  data() {
    return {
      rapConsultDossierValeur: null,
    }
  },
  methods: {
    auditAcces() {
      this.$emit('auditAcces');
    },
    auditModifications() {
      this.$emit('auditModifications');
    },
    debours() {
      this.$emit('debours');
    },
    imprimerSujet() {
      this.$emit('imprimerSujet');
    },
    imprimerSociete() {
      this.$emit('imprimerSociete');
    },
    imprimerSujetComplet() {
        this.$emit('imprimerSujetComplet');
    },
    modifier() {
      this.$emit('modifier');
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>